import { cubicOut } from 'svelte/easing'

function hslide (
    node, { delay = 0, duration = 120, easing = cubicOut }
) {
    const style = getComputedStyle(node)
    const opacity = parseFloat(style.opacity)
    const width = parseFloat(style.width)
    const paddingLeft = parseFloat(style.paddingLeft)
    const paddingRight = parseFloat(style.paddingRight)
    const marginLeft = parseFloat(style.marginLeft)
    const marginRight = parseFloat(style.marginRight)
    const borderLeftWidth = parseFloat(style.borderLeftWidth)
    const borderRightWidth = parseFloat(style.borderRightWidth)

    return {
        delay,
        duration,
        easing,
        css: t =>
            `overflow: hidden;
            opacity: ${Math.min(t * 20, 1) * opacity};
            width: ${t * width}px;
            padding-left: ${t * paddingLeft}px;
            padding-right: ${t * paddingRight}px;
            margin-left: ${t * marginLeft}px;
            margin-right: ${t * marginRight}px;
            border-left-width: ${t * borderLeftWidth}px;
            border-right-width: ${t * borderRightWidth}px;`
    }
}

function flyModified (
    node, { delay = 0, duration = 400, x = 0, y = 0, position = 'relative' }
) {
    const style = getComputedStyle(node)
    const opacity = parseFloat(style.opacity)
    const transform = style.transform !== 'none' ? style.transform : ''
    const css = t =>
        `transform: ${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px); 
        opacity: ${t * opacity}; 
        position: ${position};`

    return { delay, duration, css }
}

export {
    flyModified,
    hslide
}
